<template>
  <custom-dialog width="500px" :title="model.title" :visible="visible" v-on="$listeners" :append-to-body="true">
    <div class="dialog-body">
      <!-- 用户信息 -->
      <el-form :model="form" :rules="rules" :validate-on-rule-change="false" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('body_item_dialog_shui_hao')" prop="buyerNumber">
              <el-input v-model="form.buyerNumber" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('body_item_dialog_ming_cheng')" prop="buyerName">
              <el-input v-model="form.buyerName" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('body_item_dialog_dan_wei_di_zhi')" prop="buyerRegisterAddress">
              <el-input v-model="form.buyerRegisterAddress" type="textarea" :rows="2" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('body_item_dialog_dian_hua_hao_ma')" prop="buyerMobile">
              <el-input v-model="form.buyerMobile" placeholder=""></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item :label="$t('body_item_dialog_kai_hu_yin_hang')" prop="buyerDepositBank">
              <el-input v-model="form.buyerDepositBank" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('body_item_dialog_yhzh')" prop="buyerDepositNumber">
              <el-input v-model="form.buyerDepositNumber" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('body_item_dialog_you_xiang')" prop="buyerEmail">
              <el-input v-model.trim="form.buyerEmail" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="visible = false">{{ $t('com_cancel') }}</el-button>
      <el-button type="warning" @click="saveGroup">{{ $t('com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

// body_item_dialog_shui_hao: 税号// body_item_dialog_ming_cheng: 名称// body_item_dialog_dan_wei_di_zhi: 单位地址// body_item_dialog_dian_hua_hao_ma: 电话号码// body_item_dialog_kai_hu_yin_hang: 开户银行// body_item_dialog_yhzh: 银行账号// body_item_dialog_you_xiang: 邮箱// body_item_dialog_qtxnsdjh: 请填写纳税登记号// body_item_dialog_qtxqymc: 请填写企业名称// body_item_dialog_qtxdhhm: 请填写电话号码// body_item_dialog_cdyzgzf: 长度要在7~13个字符// body_item_dialog_qtxyhzh: 请填写银行账号// body_item_dialog_qtxzhmc: 请填写支行名称// body_item_dialog_qtxyydz: 请填写营业地址// body_item_dialog_yxgsbzq: 邮箱格式不正确

export default {
  mixins: [dialogMixins],

  data() {
    return {
      form: {
        buyerDepositBank: '', // 买方银行卡开户支行
        buyerDepositNumber: '', // 买方银行账号
        buyerMobile: '', // 买方电话号码
        buyerName: '', // 买方名称（发票抬头）
        buyerNumber: '', // 买方纳税人识别号
        buyerRegisterAddress: '', // 买方注册地址
        partnerInvoiceId: null, // 主体id [编辑时不为空]
        buyerEmail: '',
      },
      editOff: false,
    };
  },
  computed: {
    rules() {
      return {
        buyerNumber: {
          required: true,
          message: this.$t('body_item_dialog_qtxnsdjh'),
        },
        buyerName: {
          required: true,
          message: this.$t('body_item_dialog_qtxqymc'),
        },
        buyerMobile: [
          {
            required: true,
            message: this.$t('body_item_dialog_qtxdhhm'),
          },
          {
            min: 7,
            max: 13,
            message: this.$t('body_item_dialog_cdyzgzf'),
          },
        ],
        buyerDepositNumber: {
          required: true,
          message: this.$t('body_item_dialog_qtxyhzh'),
        },

        buyerDepositBank: {
          required: true,
          message: this.$t('body_item_dialog_qtxzhmc'),
        },
        buyerRegisterAddress: {
          required: true,
          message: this.$t('body_item_dialog_qtxyydz'),
        },
        buyerEmail: [
          {
            type: 'email',
            message: this.$t('body_item_dialog_yxgsbzq'),
          },
          { max: 50, message: ' ' },
        ],
      };
    },
  },
  mounted() {
    this.mergeLanguage(null, 'portal_body_item_dialog');
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        this.editOff = false;
      }
      if (this.model.type === 'edit') {
        this.$setFormatData(this.form, this.model.data);
        this.pushConfId = this.model.data.pushConfId;
        // 编辑 disabled
        this.editOff = true;
      }
    },

    // 确认保存分组
    saveGroup: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }

        if (this.model.type === 'add') {
          this.saveAddItem();
        }
        if (this.model.type === 'edit') {
          this.saveEditItem();
        }
      });
    },
    // 保存新增分组
    saveAddItem: function () {
      this.$postJSON(apis.crmPartnerInvoiceAdd, this.form, true).then(() => {
        this.$message({
          message: this.$t('com_add_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
    saveEditItem: function () {
      this.$postJSON(apis.crmPartnerInvoiceUpdate, this.form, true).then(() => {
        if (this.model.type === 'add') {
          this.$message({
            message: this.$t('com_add_success'),
            type: 'success',
          });
        } else if (this.model.type === 'edit') {
          this.$message({
            message: this.$t('com_edit_success'),
            type: 'success',
          });
        }
        this.visible = false;
        this.$emit('success');
      });
    },
  },
};
</script>

<style lang="scss"></style>
